import styled from '@emotion/styled';
import React, { FC } from 'react';

type Props = {
  borderRadius?: number;
  className?: string;
  dataTest?: string;
  color: string;
  fill: string;
  title?: string;
};

export const createSvgIcon =
  (Path: FC<Partial<Props>>, viewBox?: string) =>
  ({ className, dataTest, fill, borderRadius, title, ...rest }: Props) =>
    (
      <SVG
        {...(!title && { 'aria-hidden': true })}
        className={className}
        data-test={dataTest}
        fill={fill}
        viewBox={viewBox}
        {...rest}
      >
        {title && <title>{title}</title>}
        <Path fill={fill} borderRadius={borderRadius} />
      </SVG>
    );

const SVG = styled('svg', { shouldForwardProp: prop => !['size', 'spin', 'verticalAlign'].includes(prop) })`
  width: 1em;
  height: 1em;
`;
